export default {
  productDetail: {
    // Change types
    typeNewEntry: "New entry",
    typePriceChange: "Price change",
    typeReimbursementChange: "Reimbursement",
    typeExclusion: "Exclusion",
    typeDeduction: "Deduction",
    typeWarning: "Notice",
    typeMarketingStatus: "Market status",
    typeEuRegistration: "EU registration",
    typeExclusivity: "Exclusivity",

    // Portfolio labels
    competitor: "Competitor",
    others: "Others",

    // Header
    productFallback: "Product CN {cn}",
    registrationNo: "Registration No.",
    close: "Close",
    loading: "Loading details…",

    // Identification and laboratory
    identificationSection: "Identification and laboratory",
    activeIngredient: "Active substance",
    holderLab: "Marketing authorization holder",
    marketerLab: "Marketing company",
    pharmaceuticalForm: "Pharmaceutical form",
    administrationRoute: "Route of administration",
    dose: "Dose",
    therapeuticArea: "Therapeutic area",

    // ATC classification
    // Homogeneous group (R-05, §90 phase 2A)
    exclSection: "Protection and exclusivity",
    exclEuNumber: "EU number",
    exclFirstAuth: "First EU authorisation",
    exclPast: "already expired",
    exclDaysLeft: "{n} days left",
    exclSubject: "+1 year subject to confirmation",
    exclCalculated: "calculated date",
    ahSection: "Homogeneous group",
    ahCode: "Group",
    ahMembers: "Presentations in the group",
    ahMembersValue: "{n} CN",
    ahLowestPrice: "Lowest price in the group",
    ahOwnPrice: "This presentation's price",
    ahPrevious: "Previous group",
    atcSection: "ATC classification",
    level: "level {n}",

    // Regulatory status
    regulatoryStatusSection: "Regulatory status",
    marketed: "Marketed",
    yes: "Yes",
    no: "No",
    authorizationDate: "Authorization date",
    suspensionDate: "Suspension date",
    prescription: "Prescription",
    prescriptionRequired: "Subject to medical prescription",
    prescriptionNotRequired: "Over the counter",
    noPresentation: "No presentation marketed",
    noPresentationAut: "Since authorisation on {date} ({n} months). After 3 years the authorisation may lapse.",
    noPresentationCese: "Since marketing last ceased on {date} ({n} months). After 3 years the authorisation may lapse.",
    smpcWatch: "SmPC (section-by-section comparison)",
    smpcHtml: "Yes, CIMA SmPC",
    smpcOriginal: "Yes, SmPC of the original medicine (parallel import)",
    smpcPdf: "Yes, CIMA SmPC in PDF",
    smpcPending: "Waiting for the first read",
    smpcUnavailable: "Comparison not available: CIMA does not publish the SmPC",
    notSubstitutable: "Not substitutable",
    generic: "Generic",
    biosimilar: "Biosimilar",
    orphan: "Orphan",
    triangle: "▼ Black triangle (additional monitoring)",
    supplyProblems: "Supply problems",

    // SNS reimbursement
    financingSection: "SNS reimbursement (Bifimed)",
    financingStatus: "Reimbursement status",
    type: "Type",
    nomenclator: "Nomenclature",
    noBifimedData: "No Bifimed data for this CN.",

    // Presentations
    presentationsSection: "Presentations ({n})",
    notMarketed: "Not marketed",

    // Documents
    documentsSection: "AEMPS documents",
    datasheet: "Summary of product characteristics",
    leaflet: "Package leaflet",

    // Excipients
    excipientsSection: "Excipients ({n})",

    // Detected change history
    historySection: "Detected event history ({n})",
    noChanges: "No events recorded for this CN.",
    conceptGenericFinanced: "Reimbursed generic ex-factory price",
    conceptLowerPriceAH: "Ex-factory lower price, hospital setting (Law 29/2006)",
    conceptMandatoryDeduction: "Mandatory deduction (RDL 8/2010)",
    conceptAuthorizationDate: "Authorization date",
    conceptSafetyNote: "Safety note",
    conceptBoeResolution: "BOE resolution",
    aiSummary: "AI Summary",
    viewAempsNote: "View AEMPS note ↗",
  },
};
